import { isBlank } from '../../../helpers/common';
import { Base } from '../Base';
import { ArrayBase } from '../ArrayBase';

export class Demographic extends Base {
  age = null;
  gender = null;
  income = null;

  isValid() {
    return !isBlank(this.age) || !isBlank(this.gender) || !isBlank(this.income);
  }

  isEqualTo(other) {
    return (
      (!this.isValid() && !other.isValid()) ||
      (ArrayBase.isEqual(this.age, other.age) &&
        ArrayBase.isEqual(this.gender, other.gender) &&
        ArrayBase.isEqual(this.income, other.income))
    );
  }

  static count(target) {
    let c = 0;
    if (target.age && Array.isArray(target.age)) {
      c += target.age.length;
    }
    if (target.gender && Array.isArray(target.gender)) {
      c += target.gender.length;
    }
    if (target.income && Array.isArray(target.income)) {
      c += target.income.length;
    }
    return c;
  }
}
